import { UserOrganizationRole } from "@blinkbooks/types";

export type Role = UserOrganizationRole | null | undefined;

export const canManageTeam = (role: Role): boolean => role === UserOrganizationRole.FRACTIONAL_CFO;
export const canManageVirtualEntries = (role: Role): boolean => role === UserOrganizationRole.FRACTIONAL_CFO;
export const canSetWorkflowStatus = (role: Role): boolean =>
  role === UserOrganizationRole.FRACTIONAL_CFO || role === UserOrganizationRole.BOOKKEEPER;
export const canComment = (role: Role): boolean => !!role;

export const ROLE_LABELS: Record<UserOrganizationRole, string> = {
  [UserOrganizationRole.FRACTIONAL_CFO]: "Fractional CFO",
  [UserOrganizationRole.MANAGER]: "Manager",
  [UserOrganizationRole.BOOKKEEPER]: "Bookkeeper",
  [UserOrganizationRole.SHAREHOLDER]: "Shareholder",
};

export const ALL_ROLES: UserOrganizationRole[] = Object.values(UserOrganizationRole);
